import React from "react";
import { MapPin, Phone, Clock, Instagram, Facebook } from "lucide-react";
import { WhatsappIcon } from "./icons/WhatsappIcon";

const TopInfoBar: React.FC = () => {
  return (
    <div className="w-full bg-gray-600 text-gray-300 text-sm px-4 py-2">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-2 md:gap-6">
        <div className="flex flex-wrap gap-4 items-center">
          <div className="flex items-center gap-1 font-bold">
            <MapPin size={16} />
            <span>150 Evler Mah. 29 Mayıs Cad. NO:226 AYVALIK/BALIKESİR</span>
          </div>
          <div className="flex items-center gap-1 font-bold">
            <Phone size={16} className="font-bold" />
            <span>266 331 0 444</span>
          </div>
          <div className="flex items-center gap-1 text-green-200">
            <Clock size={16} />
            <span>Pazartesi - Cumartesi 9.00 - 18.30</span>
          </div>
        </div>
        <div className="flex gap-4 items-center text-blue-200">
          <a
            href="https://www.instagram.com/ayvalikmarin"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 cursor-pointer hover:text-white"
          >
            <Instagram size={16} />
            <span>Instagram</span>
          </a>
          <a
            href="https://www.facebook.com/ayvalikmarin"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 cursor-pointer hover:text-white"
          >
            <Facebook size={16} />
            <span>Facebook</span>
          </a>
          <a
            href="https://wa.me/905326036152"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 cursor-pointer hover:text-white"
          >
            <WhatsappIcon size={16} />
            <span>WhatsApp</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopInfoBar;
